import { useQuery } from "@tanstack/react-query";
import { useEffect } from "react";

import { StatusPanel } from "@/components/StatusPanel";
import { fetchHealth } from "@/lib/api";

/**
 * The health check, moved to `/status` by this story (spec judgement call
 * 2). Not one of the nine nav destinations — it has no `DESTINATIONS` entry
 * and no nav item — but it is a real screen this story makes reachable
 * through the shell, so it follows the same typography/token/announcement
 * rules the other nine do (review round 1 scope clarification). Its title
 * is handled here rather than by `DestinationPlaceholder`, and
 * `RouteAnnouncer` carries a matching fallback for the one path outside
 * `DESTINATIONS`.
 */
export function Status() {
  const health = useQuery({ queryKey: ["health"], queryFn: fetchHealth });

  useEffect(() => {
    document.title = "Status — PropDesk";
  }, []);

  return (
    <StatusPanel title="PropDesk">
      {health.isPending && <p className="text-body text-ink-secondary">Checking the service…</p>}
      {health.isError && <p className="text-body text-ink-secondary">The service did not answer. It may be starting up.</p>}
      {health.data && (
        <dl className="grid grid-cols-[auto_1fr] gap-x-4 gap-y-2">
          <dt className="text-label text-ink-secondary">Service</dt>
          <dd className="text-body text-ink">{health.data.status}</dd>
          <dt className="text-label text-ink-secondary">Version</dt>
          <dd className="text-body text-ink">{health.data.version}</dd>
          <dt className="text-label text-ink-secondary">Environment</dt>
          <dd className="text-body text-ink">{health.data.app_env}</dd>
          <dt className="text-label text-ink-secondary">Checked</dt>
          <dd className="text-numeric numeric-features text-ink">{health.data.checked_at}</dd>
        </dl>
      )}
    </StatusPanel>
  );
}
